export const initialState = {
  closestIndex: -1,
  isDragging: false,
  elWidth: -1,
  isTooltipActive: false,
  tension: 0.4,
  tooltipOffsetX: -1,
}

export enum ActionType {
  DRAG_START = 'DRAG_START',
  REMOVE_TOOLTIP = 'REMOVE_TOOLTIP',
  SET_TOOLTIP = 'SET_TOOLTIP',
}

type State = {
  closestIndex: number
  elWidth: number
  isDragging: boolean
  isTooltipActive: boolean
  tension: number
  tooltipOffsetX: number
}

type Action = {
  payload?: {}
  type: ActionType
}

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.DRAG_START:
      return { ...state, isDragging: true }
    case ActionType.SET_TOOLTIP:
      return {
        ...state,
        ...action.payload,
        isTooltipActive: true,
        tension: 0.1,
      }
    case ActionType.REMOVE_TOOLTIP:
      return initialState
    default:
      return state
  }
}
